var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "22",
        height: "17",
        viewBox: "0 0 22 17",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M2.44567 0.855072C1.3315 0.855072 0.427551 1.75902 0.427551 2.87319C0.427551 3.50805 0.726064 4.10508 1.2348 4.48768L10.3836 11.3493C10.8629 11.7066 11.5188 11.7066 11.9981 11.3493L21.1469 4.48768C21.6556 4.10508 21.9541 3.50805 21.9541 2.87319C21.9541 1.75902 21.0502 0.855072 19.936 0.855072H2.44567ZM0.427551 5.56401V14.3092C0.427551 15.7933 1.63422 17 3.11837 17H19.2633C20.7475 17 21.9541 15.7933 21.9541 14.3092V5.56401L12.8053 12.4256C11.8467 13.1446 10.5349 13.1446 9.57634 12.4256L0.427551 5.56401Z",
          fill: "#010A11",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }